<template>
    <div class="col dashboard__dates">
        <div class="box box--gray">
            <div class="row">
                <div class="col-lg-4">
                    <h2 class="h h--2 dashboard__dates-h2">Kontakt</h2>
                    <router-link :to="{name: 'Contact'}" class="button button--small button--fixed-width">Skontaktuj się z nami &raquo;</router-link>
                </div>
                <div class="col-lg-8">
                    <h3 class="dashboard__dates-subheader">Potrzebujesz pomocy?</h3>
                    <p>Skontaktuj się z Obsługą Programu Geberit Pro lub Doradcą Technicznym Geberit.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContactWidget',
  data () {
    return {
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/contact/ContactWidget.vue